import React, { useState, useEffect } from 'react';
import './EmpresaN.css';
import { insertUser, fetchCompanies } from './general/api';
import { useDispatch, useSelector } from 'react-redux';
import { setMenu, setCompanys } from '../actions/index';

const UsuarioN = () => {
  const dispatch = useDispatch();
  const companys = useSelector((state) => state.companys.companys); // Empresas desde Redux
  const [formData, setFormData] = useState({
    name: '',
    cc: '',
    email: '',
    tel: '',
    cargo: '',
    password: '',
    access_lvl: '2',
    company_id: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Obtener empresas si no hay en Redux
  useEffect(() => {
    const fetchCompaniesData = async () => {
      if (!companys || companys.length === 0) {
        setLoading(true);
        try {
          const companiesData = await fetchCompanies();
          dispatch(setCompanys(companiesData)); // Guardar empresas en Redux
        } catch (err) {
          console.error(err);
          setError('Error al obtener las empresas.');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCompaniesData();
  }, [companys, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.company_id) {
      alert('Por favor selecciona una empresa.');
      return;
    }
    try {
      const response = await insertUser(formData);
      console.log(response);
      alert('Usuario insertado con éxito');
      dispatch(setMenu('usuarioAct')); // Volver al listado de usuarios
    } catch (error) {
      console.error(error);
      alert('Error al insertar el usuario');
    }
  };

  return (
    <div className="empresaN">
      {loading && <p>Cargando datos de empresas...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && companys && companys.length > 0 ? (
        <form onSubmit={handleSubmit}>
          <h2>Insertar Usuario</h2>
          <label>Selecciona una Empresa:
          <select
            name="company_id"
            value={formData.company_id}
            onChange={handleChange}
            required
          >
            <option value="" disabled>
              -- Selecciona una empresa --
            </option>
            {companys.map((company) => (
              <option key={company.Id_Empresa} value={company.Id_Empresa}>
                {company.Name_Emp}
              </option>
            ))}
          </select></label>
          <label>Nombre:
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          /></label>
          <label>Identificación:
          <input
            type="text"
            name="cc"
            value={formData.cc}
            onChange={handleChange}
            required
          /></label>
          <label>Teléfono:
          <input
            type="text"
            name="tel"
            value={formData.tel}
            onChange={handleChange}
            required
          /></label>
          <label>Cargo:
          <input
            type="text"
            name="cargo"
            value={formData.cargo}
            onChange={handleChange}
            required
          /></label>
          <label>Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          /></label>
          <label>Contraseña:
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          /></label>
          <button type="submit">Guardar Usuario</button>
        </form>
      ) : (
        <p>No hay empresas disponibles. Intenta recargar la página.</p>
      )}
    </div>
  );
};

export default UsuarioN;
